/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketfirstsalescaperror4Inputs */

const en_ticketfirstsalescaperror4 = /** @type {(inputs: Ticketfirstsalescaperror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sales limit for your first event is reached.`)
};

const de_ticketfirstsalescaperror4 = /** @type {(inputs: Ticketfirstsalescaperror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Verkaufsgrenze für dein erstes Event ist erreicht.`)
};

/**
* | output |
* | --- |
* | "The sales limit for your first event is reached." |
*
* @param {Ticketfirstsalescaperror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketfirstsalescaperror4 = /** @type {((inputs?: Ticketfirstsalescaperror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketfirstsalescaperror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketfirstsalescaperror4(inputs)
	return de_ticketfirstsalescaperror4(inputs)
});
export { ticketfirstsalescaperror4 as "ticketFirstSalesCapError" }